import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { reduxReducer, setReduxReducer } from '../store';

// Buffers Gas "Containers On Site" Receiver Bank checkbox edits so they persist
// on the order Save button (legacy UpdateContainersOnSite whole-page save)
// rather than per toggle. `committed` holds values already saved this session so
// the grid keeps showing them without a refetch. Keyed by GasTrackingNumbers id.
export interface ReceiverBankState {
  pending: { [trackingNumberId: number]: boolean };
  committed: { [trackingNumberId: number]: boolean };
}

const initialState: ReceiverBankState = { pending: {}, committed: {} };

const receiverBankSlice = createSlice({
  name: 'receiverBank',
  initialState,
  reducers: {
    setPendingReceiverBank: (
      state,
      action: PayloadAction<{ trackingNumberId: number; value: boolean }>,
    ) => {
      state.pending[action.payload.trackingNumberId] = action.payload.value;
    },
    // Move saved pending toggles into committed (survives grid re-mount) and clear the buffer.
    commitReceiverBank: (state) => {
      state.committed = { ...state.committed, ...state.pending };
      state.pending = {};
    },
  },
});

export const { setPendingReceiverBank, commitReceiverBank } = receiverBankSlice.actions;
export default receiverBankSlice.reducer;

// Self-register with the root reducer at import time (same mechanism the reusable
// data-source / initListView views use), so this order-edit UI buffer is not
// hardcoded into store.ts.
reduxReducer['receiverBank'] = receiverBankSlice.reducer;
setReduxReducer(reduxReducer);
